<template>
  <el-container class="screen screen__products" direction="vertical">
    <home-marquee></home-marquee>
    <regional-highlights></regional-highlights>
    <home-favorites></home-favorites>
    <home-product-info></home-product-info>
    <home-sales-training v-if="supportedFeaturesTraining"></home-sales-training>
    <footer-main></footer-main>
  </el-container>
</template>

<script>
  import HomeMarquee from '@/components/home/HomeMarquee.vue';
  import RegionalHighlights from '@/components/home/RegionalHighlights.vue';
  import HomeProductInfo from '@/components/home/HomeProductInfo.vue';
  import HomeSalesTraining from '@/components/home/HomeSalesTraining.vue';
  import HomeFavorites from '@/components/home/HomeFavorites.vue';
  import FooterMain from '@/components/footer/FooterMain.vue';
  import mixins from '@/mixins';
  import { mapGetters, mapState } from 'vuex'
  import user from '@/components/user'
  import offline from '@/offline'

  export default {
    name: 'Home',
    mixins: [
      mixins.supportedFeatures
    ],
    computed: {
      ...mapGetters(user.store.namespace, [
        'region',
      ]),
      ...mapState(offline.store.namespace, [
        'isOnline'
      ]),
    },
    components: {
      HomeMarquee,
      RegionalHighlights,
      HomeProductInfo,
      HomeSalesTraining,
      HomeFavorites,
      FooterMain
    }
  }
</script>

<style lang="scss" scoped>
  @import 'element-theme-chalk/src/mixins/mixins.scss';

  .page {
    &--container {
      margin: 0 !important;
    }
  }
</style>
